import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-479c9563"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "old-history" }
const _hoisted_2 = { class: "old-history__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "old-history__title" }, "История наблюдений", -1))

import { computed, PropType, ref } from 'vue'
import OldHistoryChart from '@/entities/EOldObservationHistory/components/OldHistoryChart.vue'
import { OldObservationHistoryType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  observationHistory: Array as PropType<OldObservationHistoryType[]>,
},
  setup(__props) {

const props = __props



const isAllHistoryVisible = ref(false)

const visibleHistory = computed((): OldObservationHistoryType[] => {
  if (isAllHistoryVisible.value) {
    return props.observationHistory
  }

  return props.observationHistory.slice(0, 3)
})

const handleHistoryCollapse = () => {
  isAllHistoryVisible.value = !isAllHistoryVisible.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!isAllHistoryVisible.value)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "old-history__show",
            onClick: handleHistoryCollapse
          }, " Вся история "))
        : (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: "old-history__show",
            onClick: handleHistoryCollapse
          }, " Скрыть историю "))
    ]),
    _createVNode(OldHistoryChart, { history: _unref(visibleHistory) }, null, 8, ["history"])
  ]))
}
}

})